import type { NMPLocale } from "@borealis/locale-common";
import { formatNumber } from "@borealis/number-format";
import { i18n } from "@lingui/core";

export function formatDistance(distance: number, useMobilityUnit: boolean = false): string {
	if (distance < 0.1) {
		return i18n.t({
			id: "distance.less-than-100m",
			message: "100 meters or less",
		});
	} else if (distance < 1) {
		const roundedDistance = Math.round(distance * 100) * 10;
		return i18n.t({
			id: "distance.in-meters",
			message: "{distance} meters",
			values: { distance: roundedDistance },
		});
	} else if (distance < 10) {
		const roundedDistance = distance.toLocaleString(i18n.locale, {
			maximumFractionDigits: 1,
		});

		if (useMobilityUnit) {
			return i18n.t({
				id: "distance.mobility-unit",
				comment: "Mobility unit, km for finn/dba, scandinavian mile for blocket",
				message: "{distance} mil",
				values: { distance: roundedDistance },
			});
		}

		return i18n.t({
			id: "distance.with-unit",
			message: "{distance} km",
			values: { distance: roundedDistance },
		});
	} else {
		if (useMobilityUnit) {
			return i18n.t({
				id: "distance.mobility-unit",
				comment: "Mobility unit, km for finn/dba, scandinavian mile for blocket",
				message: "{distance} mil",
				values: {
					distance: formatNumber(Math.round(distance), i18n.locale as NMPLocale),
				},
			});
		}

		return i18n.t({
			id: "distance.with-unit",
			message: "{distance} km",
			values: {
				distance: formatNumber(Math.round(distance), i18n.locale as NMPLocale),
			},
		});
	}
}
